import type { PaymentOption } from "@kanda-libs/ks-frontend-services";

export type Colors = "violet" | "blue" | "green";

export const getColor = (method?: PaymentOption["payment_method"]): Colors => {
  if (method === "cash") return "violet";
  if (method === "card") return "blue";
  return "green";
};
